module.exports = new __parcel__URL__("beetlejuice-alec-baldwin.6bf8cc7a.gif").toString();